document.addEventListener("DOMContentLoaded", function () {


  function initSlider() {
    const ul = document.querySelector(".thumbnail-items-scroll-pdp");
    const upButton = document.querySelector(".arrow-up-slider");
    const downButton = document.querySelector(".arrow-down-slider");

    if (!ul || !upButton || !downButton) return;

    function checkOverflow() {
      const isOverflowing = ul.scrollHeight > ul.clientHeight;

      if (!isOverflowing) {
        upButton.classList.remove("active");
        upButton.classList.add("not-active");
        downButton.classList.remove("active");
        downButton.classList.add("not-active");
      } else {
        upButton.classList.toggle("active", ul.scrollTop > 0);
        upButton.classList.toggle("not-active", ul.scrollTop === 0);

        downButton.classList.toggle(
          "active",
          ul.scrollTop + ul.clientHeight < ul.scrollHeight
        );
        downButton.classList.toggle(
          "not-active",
          ul.scrollTop + ul.clientHeight >= ul.scrollHeight
        );
      }
    }

    function scrollUp() {
      ul.scrollBy({ top: -100, behavior: "smooth" });
    }

    function scrollDown() {
      ul.scrollBy({ top: 100, behavior: "smooth" });
    }

    upButton.removeEventListener("click", scrollUp);
    downButton.removeEventListener("click", scrollDown);
    ul.removeEventListener("scroll", checkOverflow);

    upButton.addEventListener("click", scrollUp);
    downButton.addEventListener("click", scrollDown);
    ul.addEventListener("scroll", checkOverflow);

    checkOverflow();
  }

  initSlider();
  window.addEventListener("resize", initSlider);
});

function openCartDrawer() {
  document.body.classList.add("overflow-hidden");
  document.querySelector("cart-drawer").classList.add("active");
}

function refreshCart() {
  $("#CartDrawer .drawer__inner").load(
    location.href + " #CartDrawer .drawer__inner > *",
    function () {
      initializeSwiperSlider(".swiper-container.collection-slider");
    }
  );

  $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");

  $("cart-drawer").removeClass("is-empty");
}



$(document).ready(function () {




  $(document).on('click', '.remove-all-cart-page-items', function () {
    // POST to Shopify's cart clear endpoint
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function () {

      location.reload();

    }).catch(function (error) {
      console.error('Error clearing cart:', error);
    });
  });
  


  $(document).on('click', '.remove-all-cart-items', function () {
    // POST to Shopify's cart clear endpoint
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function () {
      // Optionally reload the page or redirect to empty cart page
      // location.reload();
      

   
        var $shipping_bar = $('.free-shipping-bar');
        $shipping_bar.hide(); // Hide immediately
      
        setTimeout(function () {
          $shipping_bar.show(); // Show again after 3 seconds
        }, 3000); // 3000 milliseconds = 3 seconds
  

      // refreshCart();
      $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
      
      $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *');
      // $("cart-drawer").addClass("active");
      $("body.gradient").addClass("overflow-hidden");
      $("cart-drawer").addClass("is-empty");


    }).catch(function (error) {
      console.error('Error clearing cart:', error);
    });
  });
  






  $(".desktop-sort-options").hide();

  $(document).on("click", ".desktop-sort-title", function () {
    $(".desktop-sort-options").toggleClass("open");
    $(".desktop-sort-options").toggle();
  });

  // Set the initially checked value as the selected sort title
  // var selectedSort = $(".desktop-sort-options input:checked").next().text().trim();
  // $(".desktop-sort-title label").text(selectedSort);

  $(".desktop-sort-options input").change(function () {
    $(".desktop-sort-options").hide();
    $(".desktop-sort-options").removeClass("open");
  });

  // // Close dropdown when clicking outside
  $(document).click(function (event) {
    if (
      !$(event.target).closest(".desktop-sort-title, .desktop-sort-options")
        .length
    ) {
      $(".desktop-sort-options").removeClass("open");

      $(".desktop-sort-options").hide();
    }
  });

  $(document).on("click", ".custom-mobile-sortby", function () {
    if ($(this).hasClass("close")) {
      $(this).removeClass("close").addClass("open");
    } else {
      $(this).removeClass("open").addClass("close");
    }
  });

  // $(document).on('click', '.input-label', function(){

  //    const sku = $(this)

  // });
  // $('.mobile-product-form').hide();

  $(".mobile-featured-head").hide();

  function checkMobile() {
    if ($(window).width() <= 768) {
      // $('.mobile-product-form').show();

      // $('.model-opener').hide();

      $(".mobile-featured-head").show();

      $(".desktop-featured-head").hide();

      // $('.your-element').addClass('mobile-class');
    } else {
      // $('.your-element').removeClass('mobile-class');
    }
  }

  checkMobile();
  $(window).resize(checkMobile);
});

function initializeSwiperSlider(containerSelector) {
  // Check if Swiper is already initialized
  if (document.querySelector(containerSelector)) {
    const container = document.querySelector(containerSelector);

    // Destroy existing Swiper instance if it exists
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    // Initialize Swiper
    const swiper = new Swiper(containerSelector, {
      slidesPerView: 1.5, // Adjust based on layout
      spaceBetween: 10, // Spacing between slides
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        1024: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 1.5,
        },
        480: {
          slidesPerView: 1.5,
        },
      },
      loop: false, // Infinite loop scrolling
    });

    console.log("Swiper initialized:", swiper);
    return swiper; // Return the Swiper instance if needed
  }
}

// Initialize the slider on page load
document.addEventListener("DOMContentLoaded", () => {
  initializeSwiperSlider(".swiper-container.collection-slider");
});

$(document).on("click", ".addon-cart", function () {
  var $button = $(this); // Cache the button element
  var originalText = $button.text(); // Store the original button text
  var variantId = $button.data("id");

  // Change button text to "Adding..."
  $button.prop("disabled", true);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: variantId,
    },
    dataType: "json",
    success: function (cart) {
      // Load cart drawer content
      $("#CartDrawer .drawer__inner").load(
        location.href + " #CartDrawer .drawer__inner > *",
        function () {
          // Initialize Swiper slider once the drawer content is fully loaded
          initializeSwiperSlider(".swiper-container.collection-slider");
        }
      );

      // Open the cart drawer
      // Update cart count bubble
      $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");

      // Remove "is-empty" class from the cart drawer
      // Revert button text to the original and enable it
      $button.prop("disabled", false);
    },
    error: function (xhr, status, error) {
      console.error("Error adding product to cart:", error);

      // Revert button text to the original and enable it even on error
      $button.text(originalText).prop("disabled", false);
    },
  });
});

// custom featured collection js

jQuery(document).ready(function ($) {
  $(".sort-options").hide();

  $(".mobile-sort-title").click(function () {
    $(".sort-options").toggle();
  });

  if ($(window).width() <= 768) {
    // Check if the screen width is 768px or smaller
    // $('.mobile-menu-links').hide();
    // $('.mobile-menu-head').addClass('close');

    // $('.mobile-menu-links').hide(); // Initially hide the mobile menu links

    // $('.mobile-menu-head').click(function () {
    //   // Toggle the 'close' class if it's already 'open'
    //   if ($(this).hasClass('open')) {
    //     $(this).removeClass('open').addClass('close'); // Switch to 'close'
    //   } else {
    //     $(this).removeClass('close').addClass('open'); // Switch to 'open'
    //   }

    //   // Toggle the mobile menu links visibility
    //   $(this).next('.mobile-menu-links').toggle();
    // });

    $(window).on("scroll", function () {
      var scroll = $(window).scrollTop();

      // Check if scroll position is greater than or equal to 500
      if (scroll >= 700) {
        // Add class to the element with id or class "menu-drawer"
        $("menu-drawer").addClass("mobile-sort-by");
      } else {
        // Remove the class if the scroll is less than 500
        $("menu-drawer").removeClass("mobile-sort-by");
      }
    });
  }

  $(document).on("click", ".input-group-text.increase", function () {
    var input = $(this).parents(".input-group").find(".quantity");

    var sticky_sale_price = $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-price') ? $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-price') : $(this).parents('.card-details-inner').find('.price').attr('data-sale-price');
    var sticky_compare_price = $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-compare-price') ? $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-compare-price') : $(this).parents('.card-details-inner').find('.compare-price').attr('data-compare-price');

console.log(sticky_sale_price);
    // Remove the dollar sign and convert to float
    // var clean_price = parseFloat(sticky_price.replace('$', ''));
    var currentValue = parseInt(input.val());

    var increasedVal = currentValue + 1;
    // Multiply
    var total_price = (increasedVal * sticky_sale_price).toFixed(2);
    var total_compare_price = (increasedVal * sticky_compare_price).toFixed(2);

    input.val(currentValue + 1);
    console.log(total_price);

    $('.card-details-inner').find('.price').text('');
    $(this).parents('.card-details-inner').find('.price').text('$'+total_price);
    $(this).parents('.card-details-inner').find('.compare-price').text('$'+total_compare_price);


  });
  $(document).on("click", ".input-group-text.decrease", function () {
    var input = $(this).parents(".input-group").find(".quantity");





    var sticky_sale_price = $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-price') ? $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-price') : $(this).parents('.card-details-inner').find('.price').attr('data-sale-price');
    var sticky_compare_price = $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-compare-price') ? $(this).parents('.card-details-inner').find('.variant-item.active').attr('data-compare-price') : $(this).parents('.card-details-inner').find('.compare-price').attr('data-compare-price');



    // Remove the dollar sign and convert to float
    // var clean_price = parseFloat(sticky_price.replace('$', ''));



    var currentValue = parseInt(input.val());

    var decreasedVal = currentValue - 1;


    var total_price = (decreasedVal * sticky_sale_price).toFixed(2);
    var total_compare_price = (decreasedVal * sticky_compare_price).toFixed(2);


    

    if (currentValue > 1) {
      input.val(currentValue - 1);

      console.log(total_price);
    $('.card-details-inner').find('.price').text('');

      $(this).parents('.card-details-inner').find('.price').text('$'+total_price);
      $(this).parents('.card-details-inner').find('.compare-price').text('$'+total_compare_price);

    }
  });

  $(document).on("click", ".input-group-text.increase-cp", function () {
    var input = $(this).parents(".input-group").find(".quantity");
    var currentValue = parseInt(input.val());
    var maxValue = parseInt($(this).attr("max")); // Get the max value from the clicked button

    if (currentValue < maxValue) {
      input.val(currentValue + 1);
    }
  });

  $(document).on("click", ".input-group-text.decrease-cp", function () {
    var input = $(this).parents(".input-group").find(".quantity");
    var currentValue = parseInt(input.val());
    var maxValue = parseInt($(this).attr("max")); // Get the max value from the clicked button

    if (currentValue > 1) {
      input.val(currentValue - 1);
    }
  });

  $(document).on("input", ".quantity.form-control", function () {
    var input = $(this).val();

    // If input is less than 1 but not empty, set to 1
    if (input < 1 && input !== "") {
        input = 1;
    }

    $(this).val(input);
});

$(document).on("blur", ".quantity.form-control", function () {
    var input = $(this).val();

    // If input is empty on blur, set to 1
    if (input === "") {
        $(this).val(1);
    }
});
});

function changeVar(varId, price, compare_price, element) {
  const inventorystatus = element.getAttribute("data-inventory-status");

  if (inventorystatus === "false") {
    $(element)
      .parents(".card-details-inner")
      .find(".add-to-cart")
      .text("Sold out");
    $(element)
      .parents(".card-details-inner")
      .find(".add-to-cart")
      .attr("disabled", true);
  } else {
    $(element)
      .parents(".card-details-inner")
      .find(".add-to-cart")
      .text("Add to Cart");
    $(element)
      .parents(".card-details-inner")
      .find(".add-to-cart")
      .attr("disabled", false);
  }

  const add_to_cart_btn = $(".add-to-cart");

  if (add_to_cart_btn) {
    add_to_cart_btn.attr("data-variant-id", varId);
  }

  // Remove 'active' class from all variant buttons
  $(".variant-button").removeClass("active");

  // Add 'active' class to the clicked button
  $(element).addClass("active");

  // Update the hidden input with the selected variant ID
  $(element)
    .parents(".card-details-inner")
    .next("product-form")
    .find(".product-variant-id")
    .val(varId);

  // Format the price with two decimal places and update the price element
  // const formattedPrice = parseFloat(price).toFixed(2);
  // $(element).parents('.card-details-inner')
  //   .find('.price-item')
  //   .text(`$${formattedPrice}`);

  const formattedPrice = parseFloat(price).toFixed(2);
  $(element)
    .parents(".card-details-inner")
    .find(".price-item--sale")
    .text(`$${formattedPrice}`);

  const formattedcomparePrice = parseFloat(compare_price).toFixed(2);

  if (compare_price > 0) {
    $(element)
      .parents(".card-details-inner")
      .find(".price-item--regular")
      .text(`$${formattedcomparePrice}`);
  } else {
    $(element)
      .parents(".card-details-inner")
      .find(".price-item--regular")
      .text("");

    // const formattedPrice = parseFloat(price).toFixed(2);
    $(element)
      .parents(".card-details-inner")
      .find(".price-item")
      .text(`$${formattedPrice}`);
  }
}

$(document).ready(function () {
  cartdrawerSlider();

  function cartdrawerSlider() {
    new Swiper(".custom-drawer-slider", {
      loop: true,
      pagination: { el: ".swiper-pagination-custom", clickable: true },
      spaceBetween: 10,

      breakpoints: {
        320: { slidesPerView: "1" }, // Mobile
        768: { slidesPerView: "1" }, // iPad
        1024: { slidesPerView: "1" }, // Laptop
        1600: { slidesPerView: "1" }, // Large screens
      },
    });
  }

   $(document).on("click", ".add-to-cart", function () {
    const inventory = $(this)
      .parents(".quantity-with-cartbutton")
      .data("inventory");

    // const quantity = $(this).parents('.quantity-with-cartbutton').find('.quantity').val();

    const quantity = $(this)
      .parents(".quantity-with-cartbutton")
      .find(".quantity")
      .val()
      ? $(this).parents(".quantity-with-cartbutton").find(".quantity").val()
      : 1;

    //  const variantId = $(this).data("variant-id");
    const variantId = $(this).attr("data-variant-id");
    // if (!variantId) {
    //   alert("Please select a product variant.");
    //   return;
    // }

    if (inventory == 0) {
      return false;
    }

    const formData = {
      id: variantId,
      quantity: quantity,
    };

    // console.log(formData);

    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      data: formData,
      dataType: "json",
      success: function (response) {


        $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");

        $("#CartDrawer .drawer__inner").load(
          location.href + " #CartDrawer .drawer__inner > *",
          function () {

            $("cart-drawer").removeClass("is-empty");
        
            $("cart-drawer").addClass("active");
            $("body.gradient").addClass("overflow-hidden");
            // Initialize Swiper slider once the drawer content is fully loaded
            initializeSwiperSlider(".swiper-container.collection-slider");
          }
        );

   
      },
      error: function (xhr, status, error) {
        console.error("Error:", error);
        // alert("There was an error adding the product to the cart.");
      },
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  /*function initializePriceUpdate() {
        const quantityInput = document.querySelector(".quantity__input");

        if (!quantityInput) return;

        function updatePrice() {
            const priceElement = document.querySelector(".get-price-data-custom-add");
            if (!priceElement) return;

            const currencyCode = priceElement.getAttribute("currencycode") || "$";
            const quantity = parseInt(quantityInput.value, 10) || 1;
            const productPrice = parseFloat(priceElement.getAttribute("productprice")) || 0;
            const comparePrice = priceElement.hasAttribute("comapreprice") ? parseFloat(priceElement.getAttribute("comapreprice")) : null;

            // Select price elements
            const comparePriceElement = document.querySelector(".compare-price-custom-pdp");
            const productPriceElements = document.querySelectorAll(".custom-price-main-pdp");

            // Calculate new prices
            const newProductPrice = (productPrice * quantity).toFixed(2);
            const newComparePrice = comparePrice ? (comparePrice * quantity).toFixed(2) : null;

            if (comparePriceElement && newComparePrice) {
                comparePriceElement.innerHTML = `${currencyCode}${newComparePrice}`;
            }

            if (newProductPrice) {
                productPriceElements.forEach(element => {
                    element.innerHTML = `${currencyCode}${newProductPrice}`;
                });
            }
        }

        // Event listener for quantity buttons (+ / -)
        document.querySelectorAll(".quantity__button").forEach(button => {
            button.addEventListener("click", function () {
                setTimeout(updatePrice, 50);
            });
        });

        // Event listener for direct input change
        quantityInput.addEventListener("input", updatePrice);

        // Initial price update
        updatePrice();
    }*/

  document.addEventListener("change", function (event) {
    //event.preventDefault();
    const variantInput = event.target.closest(".variant-input"); // Detects variant input (radio button/select)
    if (!variantInput) return; // If not a variant input, exit
    // Prevent the event from bubbling up
    //event.stopPropagation();
    const selectedProductJson = document.querySelector(
      ".selected-product-json"
    );
    if (!selectedProductJson) {
      console.log("❌ No selected product data found!");
      return; // Exit if the element doesn't exist
    }

    const selected_sku = selectedProductJson.getAttribute("data-var-sku");
    const selected_bar = selectedProductJson.getAttribute("data-var-bar");
    const availability = selectedProductJson.getAttribute("data-availability");

    // Update the elements with the selected values
    document.querySelector(".mobile-sku").textContent = "SKU: " + selected_sku;
    document.querySelector(".mobile-barcode-upc-custom").textContent =
      "UPC: " + selected_bar;
    document.querySelector(".var-availability-mob").textContent = availability;

    //setTimeout(() => { // Small delay to ensure variant updates
    const selectedProductIndex = Number(selectedProductJson.value) - 1; // Get the selected variant index
    console.log("🛒 Variant Changed:", selectedProductIndex);

    // Select the button with the class 'slider-dot' and matching 'data-slide' attribute
    //const slideButton = document.querySelector(`.slider-dot[data-slide="${selectedProductIndex}"]`);
    const slideButton = document.querySelector(
      `.trigger_event_${selectedProductIndex}`
    );

    if (slideButton) {
      console.log("Triggering click for slide:", selectedProductIndex);
      slideButton.click(); // Trigger the click event on the button
    } else {
      console.warn("No button found for slide index:", selectedProductIndex);
    }
    // Optionally, update the price or perform any other actions based on the selected variant
    updateVariantDetails(selectedProductIndex);
    //}, 1000);
  });

  // Function to update variant details (you can customize this)
  function updateVariantDetails(variantIndex) {
    console.log("🛍️ Update details for variant index:", variantIndex);
    // You can add additional logic here to update the price, image, etc., based on the selected variant index.
  }

  function updatePrice(quantityInput, quantity) {
    const priceElement = quantityInput
      .closest(".product__info-container")
      .querySelector(".get-price-data-custom-add");
    if (!priceElement) return console.log("❌ No price element found!");

    const currencyCode = priceElement.getAttribute("currencycode") || "$";
    const productPrice =
      parseFloat(priceElement.getAttribute("productprice")) || 0;
    const comparePrice = priceElement.hasAttribute("comapreprice")
      ? parseFloat(priceElement.getAttribute("comapreprice"))
      : null;

    // Select price elements
    const comparePriceElement = quantityInput
      .closest(".product__info-container")
      .querySelector(".compare-price-custom-pdp");
    const productPriceElements = quantityInput
      .closest(".product__info-container")
      .querySelectorAll(".custom-price-main-pdp");

    // Calculate new prices
    const newProductPrice = (productPrice * quantity).toFixed(2);
    const newComparePrice = comparePrice
      ? (comparePrice * quantity).toFixed(2)
      : null;

    console.log(
      `💲 New Price: ${newProductPrice}, Compare Price: ${newComparePrice}`
    );

    if (comparePriceElement && newComparePrice) {
      comparePriceElement.innerHTML = `${currencyCode}${newComparePrice}`;
    }

    productPriceElements.forEach((element) => {
      element.innerHTML = `${currencyCode}${newProductPrice}`;
    });
  }

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".quantity__button"); // ✅ Detects plus/minus clicks
    if (!button) return; // If not a button, exit

    const parentContainer = button.closest(".price-per-item__container"); // ✅ Check parent container
    if (!parentContainer) return; // ❌ Exit if parent container doesn't exist

    const quantityInput = button
      .closest(".quantity")
      .querySelector(".quantity__input"); // ✅ Finds related quantity input
    if (!quantityInput) return console.log("❌ No quantity input found!");

    setTimeout(() => {
      // ✅ Small delay to ensure value updates
      const newQuantity = parseInt(quantityInput.value, 10) || 1;
      console.log("🛒 Updated Quantity:", newQuantity);
      updatePrice(quantityInput, newQuantity);
    }, 50);
  });

  // ✅ Detect when Quick View modal opens
  document.body.addEventListener("click", function (event) {
    const quickViewOpener = event.target.closest(".model-opener");
    if (quickViewOpener) {
      // Detect dynamically injected modals
      const observer = new MutationObserver((mutations, obs) => {
        const quickViewModal = document.querySelector("[id^='QuickAdd-']"); // Matches any Quick Add modal
        if (quickViewModal) {
          console.log("Quick View Modal Detected in DOM...");

          obs.disconnect(); // Stop observing new elements
          waitForModalToBeVisible(quickViewModal);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  });

  // ✅ **Wait for modal to be fully visible**
  function waitForModalToBeVisible(modal) {
    const checkVisibility = setInterval(() => {
      if (modal && window.getComputedStyle(modal).visibility === "visible") {
        console.log("Quick View Fully Opened...");
        clearInterval(checkVisibility);
        //initializePriceUpdate(); // Run function only when modal is fully open
      }
    }, 200); // Check every 200ms
  }

  // ✅ Run on page load
  //initializePriceUpdate();
});




function refreshCartDrawer() {
  $(".drawer__inner").load("/cart .drawer__inner > *", function () {
    $(".drawer").addClass("active");
    $(".drawer").removeClass("is-empty");
  });
}

function watchErrorMessages(container) {
  const errorMessageElement = container.querySelector(".product-form__error-message");

  if (!errorMessageElement) return;

  const errorObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      if ($(errorMessageElement).text().trim().length > 0) {
        refreshCartDrawer();
        $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");
      }
    });
  });

  errorObserver.observe(errorMessageElement, {
    childList: true,
    subtree: true,
  });
}

// ✅ Run on initial page load (for product page)
document.addEventListener("DOMContentLoaded", function () {
  watchErrorMessages(document);
});

// ✅ Run dynamically (for quick view modals)
const modalObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === 1) {
        if (
          node.matches(".quick-add-modal, .product-modal") ||
          node.querySelector(".product-form__error-message")
        ) {
          watchErrorMessages(node);
        }
      }
    });
  });
});

modalObserver.observe(document.body, {
  childList: true,
  subtree: true,
});



/* Cart Drawer issue when quantity is out of stock */

/* Prevent cart drawer from staying open if product form shows an error.
   Works with <product-form> custom element and theme drawer class toggles. */

(function () {
  // Helper: close the drawer by removing common theme classes/selectors
  function closeDrawerIfOpen() {
    const drawer = document.querySelector(".drawer");
    if (drawer && drawer.classList.contains("active")) {
      drawer.classList.remove("active");
    }
    // common theme classes
    document.body.classList.remove("js-drawer-open", "drawer-open");
    // also try to hide via attribute if used by theme
    if (drawer) {
      drawer.style.display = ""; // let CSS control it
    }
  }

  // Helper: check if any product form on page has an error message visible
  function productFormHasError() {
    // Queries visible error messages, including ones inside product-form
    const errEls = Array.from(document.querySelectorAll(".product-form__error-message"));
    return errEls.some(el => el && el.textContent && el.textContent.trim().length > 0);
  }

  // Observe when the drawer element is added/modified
  const bodyObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // check attribute changes on body (some themes toggle class on body)
      if (m.type === "attributes" && (m.attributeName === "class" || m.attributeName === "aria-hidden")) {
        // small delay to let theme set classes
        window.requestAnimationFrame(() => {
          if (productFormHasError()) closeDrawerIfOpen();
        });
      }

      // check for added nodes (drawer being injected)
      if (m.type === "childList" && m.addedNodes.length) {
        // if drawer appeared, wait a tick and then close if product error present
        setTimeout(() => {
          const drawer = document.querySelector(".drawer");
          if (drawer && (drawer.classList.contains("active") || window.getComputedStyle(drawer).display !== "none")) {
            if (productFormHasError()) closeDrawerIfOpen();
          }
        }, 20); // 20ms is small but gives theme code a chance to finish
      }
    }
  });

  // Start observing body for class/child changes
  bodyObserver.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true
  });

  // Also watch the drawer element itself (if it exists now or later)
  function observeDrawer() {
    const drawer = document.querySelector(".drawer");
    if (!drawer) return;
    const drawerObserver = new MutationObserver(() => {
      // if drawer becomes active, close it when there is an error
      window.requestAnimationFrame(() => {
        if (drawer.classList.contains("active") && productFormHasError()) {
          closeDrawerIfOpen();
        }
      });
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ["class"], childList: true, subtree: false });
  }

  // Try to observe existing drawer right away
  observeDrawer();

  // If a drawer gets injected later, detect it and attach observer
  const injectionObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches(".drawer")) {
          observeDrawer();
          // perform one immediate check
          setTimeout(() => { if (productFormHasError()) closeDrawerIfOpen(); }, 10);
        }
      }
    }
  });
  injectionObserver.observe(document.documentElement || document, { childList: true, subtree: true });

  // As an extra safety: if the theme opens the drawer immediately on add-to-cart,
  // but the error only appears slightly later, we also watch the product-form errors themselves.
  const errorObserver = new MutationObserver((mutations) => {
    if (productFormHasError()) {
      // small delay to allow theme handlers to run then close
      setTimeout(closeDrawerIfOpen, 10);
    }
  });

  // Observe current error message containers (if present) and also observe the whole document for any new error elements
  Array.from(document.querySelectorAll(".product-form__error-message")).forEach(el => {
    errorObserver.observe(el, { childList: true, subtree: true, characterData: true });
  });

  // Also watch for new error elements being inserted anywhere
  const docObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "childList" && m.addedNodes.length) {
        for (const n of m.addedNodes) {
          if (!(n instanceof HTMLElement)) continue;
          if (n.matches && n.matches(".product-form__error-message")) {
            errorObserver.observe(n, { childList: true, subtree: true, characterData: true });
            // If it already has text, close drawer
            if (n.textContent.trim().length > 0) setTimeout(closeDrawerIfOpen, 10);
          } else {
            // also check descendants
            const nested = n.querySelector && n.querySelector(".product-form__error-message");
            if (nested) {
              errorObserver.observe(nested, { childList: true, subtree: true, characterData: true });
              if (nested.textContent.trim().length > 0) setTimeout(closeDrawerIfOpen, 10);
            }
          }
        }
      }
    }
  });
  docObserver.observe(document.documentElement || document, { childList: true, subtree: true });

})();


/* Cart Drawer issue when quantity is out of stock */














(function () {
  'use strict';

  let rebuyFixed = false;
  let lastFocusedBeforeModal = null;

  function isRebuyVisible() {
    const container = document.querySelector('.custom-section-popup-upsell');
    if (!container) return false;
    
    const widget = container.querySelector('.rebuy-widget-container');
    if (!widget) return false;
    
    const hasClass = widget.classList.contains('is-visible');
    const isDisplayed = window.getComputedStyle(widget).display !== 'none';
    
    return hasClass && isDisplayed;
  }

  function getWidget() {
    const container = document.querySelector('.custom-section-popup-upsell');
    if (!container) return null;
    
    const widget = container.querySelector('.rebuy-widget-container.is-visible');
    if (!widget) return null;
    
    if (window.getComputedStyle(widget).display === 'none') return null;
    
    return widget;
  }

  function getFocusableElements(widget) {
    const all = [];

    const closeBtn = widget.querySelector('.rebuy-modal-close');
    if (closeBtn) all.push(closeBtn);

    const rest = Array.from(widget.querySelectorAll(
      '.rebuy-product-title-link, .rebuy-select, .rebuy-product-actions .rebuy-button, .rebuy-button.decline'
    )).filter(function (el) {
      const s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
    });

    all.push(...rest);
    return all;
  }

  function onTrapKeydown(e) {
    if (!isRebuyVisible()) return;

    const widget = getWidget();
    if (!widget) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();
      const closeBtn = widget.querySelector('.rebuy-modal-close');
      if (closeBtn) closeBtn.click();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusable = getFocusableElements(widget);
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const current = document.activeElement;

    if (!widget.contains(current) || current === widget) {
      e.preventDefault();
      first.focus();
      return;
    }

    if (e.shiftKey) {
      if (current === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (current === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function setupCloseButton(closeBtn, widget) {
    if (closeBtn.hasAttribute('data-key-fixed')) return;
    closeBtn.setAttribute('data-key-fixed', 'true');

    closeBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeBtn.click();
        return;
      }
      
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const focusable = getFocusableElements(widget);
        const last = focusable[focusable.length - 1];
        if (last) last.focus();
        return;
      }
      
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const focusable = getFocusableElements(widget);
        const idx = focusable.indexOf(closeBtn);
        const next = focusable[idx + 1];
        if (next) next.focus();
      }
    }, true);

    closeBtn.addEventListener('focus', function () {
      closeBtn.style.outline = '2px solid #005fcc';
      closeBtn.style.outlineOffset = '2px';
    });
    
    closeBtn.addEventListener('blur', function () {
      closeBtn.style.outline = '';
      closeBtn.style.outlineOffset = '';
    });
  }

  function fixRebuyFocus() {
    const widget = getWidget();
    
    if (!widget) {
      console.log('No valid widget found');
      return;
    }

    if (rebuyFixed) {
      console.log('Already fixed');
      return;
    }

    console.log('✅ Setting up Rebuy accessibility...');
    rebuyFixed = true;

    lastFocusedBeforeModal = document.activeElement;
    console.log('💾 Saved last focused element:', lastFocusedBeforeModal);

    widget.setAttribute('tabindex', '-1');
    widget.setAttribute('role', 'dialog');
    widget.setAttribute('aria-modal', 'true');

    // ✅ title sirf aria-labelledby ke liye — tab order mein nahi
    const title = widget.querySelector('.primary-title');
    if (title) {
      title.setAttribute('tabindex', '-1');
      title.setAttribute('id', 'rebuy-primary-title');
      widget.setAttribute('aria-labelledby', 'rebuy-primary-title');
    }

    const superTitle = widget.querySelector('.super-title');
    if (superTitle) superTitle.setAttribute('tabindex', '-1');

    const carousel = widget.querySelector('.rebuy-product-grid');
    if (carousel) carousel.setAttribute('tabindex', '-1');

    widget.querySelectorAll('.splide__arrow')
      .forEach(function (el) { el.setAttribute('tabindex', '-1'); });

    widget.querySelectorAll('.rebuy-money span')
      .forEach(function (el) {
        el.setAttribute('tabindex', '-1');
        const text = el.textContent.trim();
        if (text) el.setAttribute('aria-label', 'Price ' + text);
      });

    widget.querySelectorAll('.splide__pagination__page')
      .forEach(function (el) { el.setAttribute('tabindex', '-1'); });

    widget.querySelectorAll('.powered-by-rebuy a')
      .forEach(function (el) { el.setAttribute('tabindex', '-1'); });

    widget.querySelectorAll('.rebuy-product-image')
      .forEach(function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });

    const closeBtn = widget.querySelector('.rebuy-modal-close');
    if (closeBtn) {
      closeBtn.setAttribute('tabindex', '0');
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('aria-label', 'Close dialog');
      setupCloseButton(closeBtn, widget);
    }

    widget.querySelectorAll(
      '.rebuy-product-title-link, .rebuy-select, .rebuy-product-actions .rebuy-button'
    ).forEach(function (el) { el.setAttribute('tabindex', '0'); });

    const continueBtn = widget.querySelector('.rebuy-button.decline');
    if (continueBtn) {
      continueBtn.setAttribute('tabindex', '0');
      continueBtn.setAttribute('aria-label', 'Continue shopping, close dialog');
    }

    document.addEventListener('keydown', onTrapKeydown, true);

    // ✅ Close button pe focus — title/widget skip
    setTimeout(function () {
      const closeBtn = widget.querySelector('.rebuy-modal-close');
      if (closeBtn) {
        // closeBtn.focus();
         widget.focus();
        console.log('✅ Close button focused');
      } else {
        widget.focus();
        console.log('✅ Widget focused (fallback)');
      }
    }, 400);
  }

  function resetRebuy() {
    if (!rebuyFixed) {
      console.log('❌ resetRebuy called but rebuyFixed is false - skipping');
      return;
    }
    
    console.log('🔄 Resetting Rebuy accessibility...');
    rebuyFixed = false;
    document.removeEventListener('keydown', onTrapKeydown, true);
    
    console.log('🔙 Attempting to restore focus to:', lastFocusedBeforeModal);
    
    if (lastFocusedBeforeModal) {
      setTimeout(function() {
        if (lastFocusedBeforeModal && typeof lastFocusedBeforeModal.focus === 'function') {
          try {
            lastFocusedBeforeModal.focus();
            console.log('✅ Focus restored successfully');
          } catch (err) {
            console.error('❌ Failed to restore focus:', err);
          }
        }
        lastFocusedBeforeModal = null;
      }, 200);
    } else {
      console.log('⚠️ No lastFocusedBeforeModal to restore');
    }
  }

  function checkRebuyState() {
    const visible = isRebuyVisible();
    console.log('🔍 State check - visible:', visible, 'rebuyFixed:', rebuyFixed);
    
    if (visible && !rebuyFixed) {
      fixRebuyFocus();
    } else if (!visible && rebuyFixed) {
      resetRebuy();
    }
  }

  function startObserver() {
    const container = document.querySelector('.custom-section-popup-upsell');
    
    if (!container) {
      // console.log('⏳ Waiting for .custom-section-popup-upsell...');
      setTimeout(startObserver, 500);
      return;
    }

    // console.log('✅ Found .custom-section-popup-upsell - starting observer');

    const observer = new MutationObserver(function () {
      checkRebuyState();
    });

    observer.observe(container, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });

    checkRebuyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  console.log('🚀 Rebuy accessibility script loaded');

})();


/* TAB indexing */


function fixRebuyTabIndex() {
  document.querySelectorAll('.rebuy-product-media a.rebuy-product-image').forEach(el => {
    el.setAttribute('tabindex', '0');
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', fixRebuyTabIndex);

// Run after delay (for async load)
setTimeout(fixRebuyTabIndex, 1000);
setTimeout(fixRebuyTabIndex, 2000);

// Observe dynamic changes (BEST PART)
const observer = new MutationObserver(() => {
  fixRebuyTabIndex();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});






document.addEventListener("DOMContentLoaded", function () {

  function hideEmptyFilterOptions() {
    document.querySelectorAll('.boost-sd__filter-option-item').forEach(function(item) {
      const label = item.querySelector('.boost-sd__filter-option-item-label');
      
      if (label && label.textContent.trim() === '[]') {
        item.style.display = 'none';
      }
    });
  }

  hideEmptyFilterOptions();

  // Observe entire document because Boost re-renders filters via AJAX
  const observer = new MutationObserver(function() {
    hideEmptyFilterOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});






$(document).on("click", ".predictive_add_to_cart", function () {
  var $button = $(this);
  var productid = $(this).data("id");
  var product_qty = $(this).data("product-qty");
  $button.find(".loading__spinner").removeClass("hidden");
  $button.find(".text-button").addClass("no_visibility");
  
  if (productid) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: productid,
        quantity: product_qty,
      },
      dataType: "json",
       success: function (response) {
  console.log("Product added to cart:", response);

   $(".cart-count-bubble").load(location.href + " .cart-count-bubble > *");

        $("#CartDrawer .drawer__inner").load(
          location.href + " #CartDrawer .drawer__inner > *",
          function () {

            $("cart-drawer").removeClass("is-empty");
        
            $("cart-drawer").addClass("active");
            $("body.gradient").addClass("overflow-hidden");
            // Initialize Swiper slider once the drawer content is fully loaded
            initializeSwiperSlider(".swiper-container.collection-slider");
                $button.find(".loading__spinner").addClass("hidden");
    $button.find(".text-button").removeClass("no_visibility");
          }
        );


},
      // success: function (response) {
      //   console.log("Product added to cart:", response);
      //   $(".drawer__inner").load("/cart .drawer__inner > *", function () {
      //     $(".drawer").addClass("active");
      //     $(".drawer").removeClass("is-empty");
      //     $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
      //      $button.find(".loading__spinner").addClass("hidden");
      //      $button.find(".text-button").removeClass("no_visibility");
      //     window.initializeCartAddOnSwiper();
      //   });
      //   //  window.location.href = "/cart";
      // },
      error: function (xhr, status, error) {
        console.error("Error adding product to cart:", xhr.responseText);
         $button.find(".loading__spinner").addClass("hidden");
         $button.find(".text-button").removeClass("no_visibility");
         try {
        const response = JSON.parse(xhr.responseText);
        if (response && response.message) {
          showATCErrorPopup(response.message);
          $button.find(".text-button").removeClass("no_visibility");
        }
      } catch (e) {
        // showATCErrorPopup("Something went wrong. Please try again.");
      }
      },
    });
  } else {
    console.log("Product ID not found.");
     $button.find(".loading__spinner").addClass("hidden");
      $button.find(".text-button").removeClass("no_visibility");
  }
});